module.exports = __webpack_public_path__ + "static/media/5.39a7588b.png";